import { Box, TextField, Typography } from "@mui/material"
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { GetExtraWorkAgreementQueryResponse } from "api/generatedApi";
import { Control, Controller, UseFormGetValues, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { ExtraWorkAgreementFormData } from "../hooks/use-input-validation";
import { useTranslation } from "react-i18next";

export interface Props {
  disabled: boolean;
  control: Control<ExtraWorkAgreementFormData>;
}

export const DescriptionCard = (props: Props) => {
  const { disabled, control } = props;
  const { t } = useTranslation();
  return (
    <Box sx={{
      display: "flex",
      flexDirection: "row",
      gap: 1,
      "@media print": {
        maxHeight: "none",
        overflow: "visible",
      }
    }}>


      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <>
            <TextField
              {...field}
              fullWidth
              multiline
              minRows={3}
              maxRows={8}
              disabled={disabled}
              variant="standard"
              placeholder={t("dashboard.extraWorkAgreements.create.placeholderDescription")}
              value={field.value || ""}
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                whiteSpace: "pre-wrap",
                overflowWrap: "break-word",
                "@media print": {
                  display: "none",
                },
              }}
            />
            {/* Added second typography for print with same styles to bypass maxrows = 8 while printing */}
            <Typography
              sx={{
                display: "none",
                whiteSpace: "pre-wrap",
                overflowWrap: "break-word",
                width: "100%",
                "@media print": {
                  display: "block",
                },
              }}
            >
              {field.value || ""}
            </Typography>
          </>
        )}
      />
    </Box>
  )
}

